<template>
    <div>
        <h4>
            {{
                selectedTemplate && selectedTemplate.name
                    ? `Review Template: ${
                          selectedTemplate && selectedTemplate.name
                      }`
                    : 'No Review Template'
            }}
        </h4>

        <b-modal
            v-model="processModal"
            id="process-modal"
            :title="`Process: ${
                selectedItem &&
                selectedItem.checkoff_type &&
                selectedItem.checkoff_type.name
            }`"
            @ok="submitCheckoff"
            size="lg"
        >
            <b-card no-body v-if="processModal">
                <b-tabs card v-model="tabIdx">
                    <b-tab title="Summary" active>
                        <b-card-body>
                            <view-checkoff-summary
                                v-if="selectedItem.status == 'completed'"
                                :checkoff="selectedItem"
                            />
                            <view-checkoff-form
                                v-else
                                :status="selectedItem.status"
                                v-model="model"
                            />
                        </b-card-body>
                    </b-tab>
                    <b-tab title="Images">
                        <b-card-body>
                            <view-checkoff-attachments
                                :order_id="order.id"
                                :order_checkoff_id="selectedItem.id"
                                @attachment-added="updateStatus"
                            ></view-checkoff-attachments>
                        </b-card-body>
                    </b-tab>
                </b-tabs>
            </b-card>

            <template #modal-footer="{ ok, cancel }">
                <b-button
                    size="sm"
                    variant="success"
                    @click="ok()"
                    v-if="
                        selectedItem.status != 'completed' &&
                        tabIdx === checkoffTabs.summary
                    "
                    v-show="hasPermissionUpdate"
                >
                    Submit
                </b-button>

                <b-button size="sm" variant="warning" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <b-table
            striped
            hover
            :items="checkoffItems"
            :fields="fields"
            show-empty
        >
            <template #table-colgroup="scope">
                <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{
                        width:
                            field.key === 'sequence_no'
                                ? '150px'
                                : field.key !== 'id'
                                ? '350px'
                                : null,
                    }"
                />
            </template>

            <template #cell(status)="{ item }">
                <b-badge :variant="item.status | actionVariant">{{
                    item.status
                }}</b-badge>
            </template>

            <template #cell(action)="{ item }">
                <b-button
                    size="sm"
                    :disabled="item.status != 'completed' && !item.active"
                    :variant="item.status | actionVariant"
                    @click="openProcessModal(item)"
                    >{{ item.status | actionLabel }}</b-button
                >
            </template>
            <template #cell(created_at)="{ value }">
                <h6>{{ value | displayTime(true) }}</h6>
            </template>
            <template #cell(completed_at)="{ value }">
                <h6>{{ value | displayTime(true) }}</h6>
            </template>
        </b-table>
    </div>
</template>
<script>
import ViewCheckoffSummary from './ViewCheckoffSummary.vue'
import ViewCheckoffForm from './ViewCheckoffForm.vue'
import ViewCheckoffAttachments from './ViewCheckoffAttachments.vue'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import moment from 'moment'

export default {
    name: 'orders-Checkoff',
    components: {
        ViewCheckoffSummary,
        ViewCheckoffForm,
        ViewCheckoffAttachments,
    },
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        processModal: false,

        fields: [
            { key: 'sequence_no' },
            {
                key: 'checkoff_type',
                label: 'Review Type',
                formatter: value => value.name,
            },
            { key: 'status', label: 'Status' },
            { key: 'created_at', label: 'Reviewed On' },
            { key: 'completed_at', label: 'Completed On' },
            {
                key: 'user',
                label: 'Actioned By',
                formatter: x =>
                    ((x || {}).first_name || '') +
                    ' ' +
                    ((x || {}).last_name || ''),
            },
            { key: 'action', label: '' },
        ],
        model: {
            comments: null,
            // completed_at
            checkoff_type_id: null,
        },
        selectedItem: null,
        loading: false,
        tabIdx: 0,
    }),
    filters: {
        actionLabel(status) {
            switch (status) {
                case 'pending':
                case 'processing':
                    return 'Process'
                case 'completed':
                    return 'View'
            }
        },
        actionVariant(status) {
            switch (status) {
                case 'pending':
                    return 'warning'
                case 'processing':
                    return 'info'
                case 'completed':
                    return 'success'
            }
        },
        displayTime(time) {
            //console.log("time",time)
            var retutnTime = "N/A"
           if(time !=''){ 
                retutnTime = moment(time, 'YYYY-MM-DD HH:mm:ss').format(
                    'YYYY-MM-DD, h:mm:ss a'
                )
           }
           return retutnTime
        },
    },
    computed: {
        checkoffTabs() {
            return {
                summary: 0,
                images: 1,
            }
        },
        user() {
            return this.$store.state.user
        },
        order() {
            const item = this.$store.state.orders.item
            console.log('computed---order', item)
            return item || {}
        },
        checkoffItems() {
            let items = [...((this.order && this.order.checkoffs) || [])]
            //add status
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                const status = item.completed
                    ? 'completed'
                    : item.user_id || item.checkoff_attachments.length
                    ? 'processing'
                    : 'pending'
                this.$set(item, 'status', status)
                this.$set(items, i, item)
            }

            //sort
            items.sort((a, b) => a.sequence_no - b.sequence_no)

            //determine active state
            let firstAvailableItem = null
            for (let i = 0; i < items.length; i++) {
                const item = items[i]

                this.$set(item, 'active', false)
                if (!firstAvailableItem && item.status != 'completed') {
                    firstAvailableItem = item
                    this.$set(item, 'active', true)
                }

                if (
                    firstAvailableItem &&
                    item.status != 'completed' &&
                    firstAvailableItem.sequence_no == item.sequence_no
                ) {
                    this.$set(item, 'active', true)
                }

                if (item.status != 'completed') {
                    const user_role = this.user.roles[0].role_id
                    console.log('user role', user_role)
                    const type_roles = item.checkoff_type.checkoff_type_roles
                    console.log('type roles', type_roles)
                    const userHasRole = type_roles.some(
                        x => x.role_id === user_role
                    ) /*  ||  type_roles.length === 0  */
                    console.log('userHasRole', userHasRole)
                    if (item.active) this.$set(item, 'active', userHasRole)
                }
                console.log('item.active', item.active)
                this.$set(items, i, item)
            }

            console.log('Check Off Items - ', items)
            return items
        },
        selectedTemplate() {
            return this.order.checkoff_template
        },
    },
    mounted() {
        console.log('checkoff user', this.user)
        console.log('checkoff order', this.order)
    },
    methods: {
        displayStatus(value) {
            return `<div>23456${value}</div>`
        },

        openProcessModal(item) {
            this.selectedItem = item
            console.log('item', item)
            this.model.checkoff_type_id = item.checkoff_type_id
            this.model.comments = item.comments
            this.model.completed = item.completed
            console.log('model before', this.model)
            this.processModal = true
        },

        getPosition(options) {
            return new Promise((resolve, reject) =>
                navigator.geolocation.getCurrentPosition(
                    resolve,
                    reject,
                    options
                )
            )
        },

        updateStatus() {
            if (!this.selectedItem.user_id) {
                this.submitCheckoff(true)
            }
        },

        async submitCheckoff() {
            console.log('model after.........................................', this.model)

            try {
                this.loading = true
                const {
                    order: { id },
                    model: { comments, checkoff_type_id, completed },
                } = this

                if (!navigator.geolocation) {
                    throw new Error(
                        'Cannot identify your location. Ensure your browser is enabled for GeoLocation'
                    )
                }
                const position = await this.getPosition()

                let lat = position.coords.latitude
                let long = position.coords.longitude
                const data = {
                    checkoff_type_id,
                    comments,
                    lat,
                    long,
                    completed,
                }

                const path = 'orders/updateCheckoff'
                const order_checkoff_id = this.selectedItem.id

                await this.$store.dispatch(path, {
                    id,
                    order_checkoff_id,
                    data,
                })

                this.processModal = false
                this.genericToast(
                    'Activity Review',
                    'Updated',
                    'success',
                    `Activity Review successfully updated`
                )
            } catch (err) {
                this.doToast('Error!', err.message, 'danger')
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
